import React from 'react';
import { useEffect, useState } from 'react';

import { useBrandsRangesFilter } from '@/hooks/filters/brands-ranges-filter.hook';
import { makeKiaFirst } from '@/services/filters/filters.service';

import { NestedCheckboxesSimple } from '../../nested-checkboxes-simple/nested-checkboxes';
import { MobileFilter } from '../mobile-filter/mobile-filter';

export const BrandsRangesSimple: React.FC<{
  handleVisibleChange?: (isVisible: boolean) => void;
  isVisible?: boolean;
}> = ({ handleVisibleChange, isVisible }) => {
  const {
    brandsRangesAllSelected,
    brandsRangesFilter,
    setBrandsRangesFilter,
    toggleBrandRange,
  } = useBrandsRangesFilter();

  const [brandsRanges, setBrandRanges] = useState(brandsRangesFilter);

  useEffect(() => {
    if (isVisible) {
      setBrandRanges(brandsRangesFilter);
    }
  }, [isVisible]);

  const onClose = () => {
    setBrandsRangesFilter(brandsRanges);
  };

  return (
    <MobileFilter
      title="Make & Model"
      handleVisibleChange={handleVisibleChange}
      isVisible={isVisible}
      onClose={onClose}
    >
      <NestedCheckboxesSimple
        selectFilter={(option) => {
          toggleBrandRange(option);
        }}
        options={makeKiaFirst(brandsRangesFilter)}
        setOptionsState={setBrandsRangesFilter}
        resetText="Reset Filters"
        selectAllText="All"
        hideText="Hide Models"
        openText="Show Models"
        allSelected={brandsRangesAllSelected}
      />
    </MobileFilter>
  );
};
